import React, { useState } from 'react';
import useAuth from '../hooks/useAuth';
import './Login.css';

function Login() {
    const [loginField, setLoginField] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { login } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;
        setError('');
        setIsSubmitting(true);
        try {
            await login(loginField, password);
        } catch (err) {
            if (err.response && err.response.data) {
                const d = err.response.data;
                setError(typeof d === 'string' ? d : d.message || d.error || `Ошибка ${err.response.status}. Попробуйте позже.`);
            } else {
                setError('Не удалось войти. Проверьте ваше подключение к сети.');
            }
            setIsSubmitting(false);
        }
    };

    return (
        <div className="login-container">
            <form onSubmit={handleSubmit} className={`login-form ${isSubmitting ? 'is-submitting' : ''}`}>
                <h2 className="fantasy-hub-title">Fantasy Hub</h2>
                {error && <p className="error">{error}</p>}
                <div className="form-group">
                    <label htmlFor="login">Логин</label>
                    <input
                        type="text"
                        id="login"
                        value={loginField}
                        onChange={(e) => setLoginField(e.target.value)}
                        required
                        disabled={isSubmitting}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Пароль</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        disabled={isSubmitting}
                    />
                </div>
                <button type="submit" disabled={isSubmitting} className="login-submit-btn">
                    {isSubmitting ? (
                        <span className="btn-progress">
                            <span className="spinner" />
                            Входим…
                        </span>
                    ) : (
                        'Войти'
                    )}
                </button>
            </form>
            {isSubmitting && (
                <div className="auth-loading-overlay">
                    <div className="auth-loader">
                        <div className="auth-ring" />
                        <div className="auth-text">Авторизация…</div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Login;
